import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ContactResponse } from '../../../admin/interfaces/find-email.interface';

@Component({
    standalone: false,
    selector: 'por-contact-actions-renderer',
    templateUrl: './contact-actions.html',
    styleUrls: ['./contact-actions.scss']
})
export class ContactActionsRendererComponent implements ICellRendererAngularComp {
    public params!: ICellRendererParams;
    public contact!: ContactResponse;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.contact = { ...params.data };
    }

    onDeactivate(): void {
        this.params.context?.componentParent?.onDeactivate(this.contact);
    }

    onActivate(): void {
        this.params.context?.componentParent?.onActivate(this.contact);
    }

    refresh(): boolean {
        return false;
    }
}
